import type { IFetcher } from "../../util/io/Fetcher";
import type { GetNewsMenuResponse } from "../responses/GetNewsMenuResponse";
import type { GetCurrentEnvironmentResponse } from "../responses/GetCurrentEnvironmentResponse";
import type { GetAllEnvironmentsResponse } from "../responses/GetAllEnvironmentsResponse";

export interface IPOW3Fetchers {
    getNewsMenu(): Promise<GetNewsMenuResponse>;

    getCurrentEnvironment(): Promise<GetCurrentEnvironmentResponse>;

    getAllEnvironments(excludeCurrent: boolean): Promise<GetAllEnvironmentsResponse>;
}

export class POW3Fetchers implements IPOW3Fetchers {
    constructor(private readonly fetcher: IFetcher) {}

    async getNewsMenu(): Promise<GetNewsMenuResponse> {
        const { fetcher } = this;
        const url = "/POW3/Resource/BannerInfo";
        return await fetcher.getJSON<GetNewsMenuResponse>(url);
    }

    async getCurrentEnvironment(): Promise<GetCurrentEnvironmentResponse> {
        const { fetcher } = this;
        const url = "/POW3/Account/GetCurrentEnvironment";
        return await fetcher.getJSON<GetCurrentEnvironmentResponse>(url);
    }

    async getAllEnvironments(excludeCurrent: boolean): Promise<GetAllEnvironmentsResponse> {
        const { fetcher } = this;
        const url = "/POW3/Account/GetAllEnvironments?excludeCurrent=" + excludeCurrent;
        return await fetcher.getJSON<GetAllEnvironmentsResponse>(url);
    }
}
